import { IApplicationState } from '../../types/redux';

export const selectOffersCount = ({ ids }: IApplicationState) => {
  return ids.length;
};
